import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Layout from "../views/layout/index.vue";
import order from './order'
import product from './product'
import organ from './organ'
import agreement from './agreement'
import operator from './operator'
import log from './log'



// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location: any) {
  return (originalPush.call(this, location) as any).catch((err: any) => err)
}

Vue.use(VueRouter);

export const constantRoutes: RouteConfig[] = [
  {
    path: '/redirect/:path(.*)',
    component: () => import('@/views/redirect/index.vue'),
    meta: { hidden: true },
  },
  {
    path: '/login',
    component: () => import('@/views/login.vue'),
    meta: {
      title: '登录',
      nologin: true
    }
  },
  {
    path: "/",
    redirect: "/home",
    component: Layout,
    children: [...order, ...product, ...organ, ...agreement, ...operator, ...log,
      {
        path: 'home',
        name: 'home',
        component: () => import('@/views/Home.vue'),
        meta: {
          title: '首页'
        }
      }
      ]
  },
  {
    path: '/autologin',
    component: () => import('@/views/autologin.vue'),
    meta: {
      title: '自动登录',
      nologin: true
    }
  },
]


const router = new VueRouter({
  routes: constantRoutes,
});


export default router;
